/*!@preserve 
 *
 * Cheasure base.js 
 * 
 */
var base = window.base || {}; 


/////////////////////////// 
//    Utilities          //
///////////////////////////

/** jQuery throttle / debounce v1.1 
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 */
(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);
/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages=function(){"use strict";function t(t,e){return"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='"+t+"' height='"+e+"'%3E%3C/svg%3E"}function e(t){if(t.srcset&&!p&&window.picturefill){var e=window.picturefill._;t[e.ns]&&t[e.ns].evaled||e.fillImg(t,{reselect:!0}),t[e.ns].curSrc||(t[e.ns].supported=!1,e.fillImg(t,{reselect:!0})),t.currentSrc=t[e.ns].curSrc||t.src}}function i(t){for(var e,i=getComputedStyle(t).fontFamily,r={};null!==(e=u.exec(i));)r[e[1]]=e[2];return r}function r(e,i,r){var n=t(i||1,r||0);b.call(e,"src")!==n&&h.call(e,"src",n)}function n(t,e){t.naturalWidth?e(t):setTimeout(n,100,t,e)}function c(t){var c=i(t),o=t[l];if(c["object-fit"]=c["object-fit"]||"fill",!o.img){if("fill"===c["object-fit"])return;if(!o.skipTest&&f&&!c["object-position"])return}if(!o.img){o.img=new Image(t.width,t.height),o.img.srcset=b.call(t,"data-ofi-srcset")||t.srcset,o.img.src=b.call(t,"data-ofi-src")||t.src,h.call(t,"data-ofi-src",t.src),t.srcset&&h.call(t,"data-ofi-srcset",t.srcset),r(t,t.naturalWidth||t.width,t.naturalHeight||t.height),t.srcset&&(t.srcset="");try{s(t)}catch(t){window.console&&console.warn("https://bit.ly/ofi-old-browser")}}e(o.img),t.style.backgroundImage='url("'+(o.img.currentSrc||o.img.src).replace(/"/g,'\\"')+'")',t.style.backgroundPosition=c["object-position"]||"center",t.style.backgroundRepeat="no-repeat",t.style.backgroundOrigin="content-box",/scale-down/.test(c["object-fit"])?n(o.img,function(){o.img.naturalWidth>t.width||o.img.naturalHeight>t.height?t.style.backgroundSize="contain":t.style.backgroundSize="auto"}):t.style.backgroundSize=c["object-fit"].replace("none","auto").replace("fill","100% 100%"),n(o.img,function(e){r(t,e.naturalWidth,e.naturalHeight)})}function s(t){var e={get:function(e){return t[l].img[e?e:"src"]},set:function(e,i){return t[l].img[i?i:"src"]=e,h.call(t,"data-ofi-"+i,e),c(t),e}};Object.defineProperty(t,"src",e),Object.defineProperty(t,"currentSrc",{get:function(){return e.get("currentSrc")}}),Object.defineProperty(t,"srcset",{get:function(){return e.get("srcset")},set:function(t){return e.set(t,"srcset")}})}function o(){function t(t,e){return t[l]&&t[l].img&&("src"===e||"srcset"===e)?t[l].img:t}d||(HTMLImageElement.prototype.getAttribute=function(e){return b.call(t(this,e),e)},HTMLImageElement.prototype.setAttribute=function(e,i){return h.call(t(this,e),e,String(i))})}function a(t,e){var i=!y&&!t;if(e=e||{},t=t||"img",d&&!e.skipTest||!m)return!1;"img"===t?t=document.getElementsByTagName("img"):"string"==typeof t?t=document.querySelectorAll(t):"length"in t||(t=[t]);for(var r=0;r<t.length;r++)t[r][l]=t[r][l]||{skipTest:e.skipTest},c(t[r]);i&&(document.body.addEventListener("load",function(t){"IMG"===t.target.tagName&&a(t.target,{skipTest:e.skipTest})},!0),y=!0,t="img"),e.watchMQ&&window.addEventListener("resize",a.bind(null,t,{skipTest:e.skipTest}))}var l="fregante:object-fit-images",u=/(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g,g="undefined"==typeof Image?{style:{"object-position":1}}:new Image,f="object-fit"in g.style,d="object-position"in g.style,m="background-size"in g.style,p="string"==typeof g.currentSrc,b=g.getAttribute,h=g.setAttribute,y=!1;return a.supportsObjectFit=f,a.supportsObjectPosition=d,o(),a}();

/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
!function(a){var b=navigator.userAgent;a.HTMLPictureElement&&/ecko/.test(b)&&b.match(/rv\:(\d+)/)&&RegExp.$1<45&&addEventListener("resize",function(){var b,c=document.createElement("source"),d=function(a){var b,d,e=a.parentNode;"PICTURE"===e.nodeName.toUpperCase()?(b=c.cloneNode(),e.insertBefore(b,e.firstElementChild),setTimeout(function(){e.removeChild(b)})):(!a._pfLastSize||a.offsetWidth>a._pfLastSize)&&(a._pfLastSize=a.offsetWidth,d=a.sizes,a.sizes+=",100vw",setTimeout(function(){a.sizes=d}))},e=function(){var a,b=document.querySelectorAll("picture > img, img[srcset][sizes]");for(a=0;a<b.length;a++)d(b[a])},f=function(){clearTimeout(b),b=setTimeout(e,99)},g=a.matchMedia&&matchMedia("(orientation: landscape)"),h=function(){f(),g&&g.addListener&&g.addListener(f)};return c.srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",/^[c|i]|d$/.test(document.readyState||"")?h():document.addEventListener("DOMContentLoaded",h),f}())}(window),function(a,b,c){"use strict";function d(a){return" "===a||"	"===a||"\n"===a||"\f"===a||"\r"===a}function e(b,c){var d=new a.Image;return d.onerror=function(){A[b]=!1,ba()},d.onload=function(){A[b]=1===d.width,ba()},d.src=c,"pending"}function f(){M=!1,P=a.devicePixelRatio,N={},O={},s.DPR=P||1,Q.width=Math.max(a.innerWidth||0,z.clientWidth),Q.height=Math.max(a.innerHeight||0,z.clientHeight),Q.vw=Q.width/100,Q.vh=Q.height/100,r=[Q.height,Q.width,P].join("-"),Q.em=s.getEmValue(),Q.rem=Q.em}function g(a,b,c,d){var e,f,g,h;return"saveData"===B.algorithm?a>2.7?h=c+1:(f=b-c,e=Math.pow(a-.6,1.5),g=f*e,d&&(g+=.1*e),h=a+g):h=c>1?Math.sqrt(a*b):a,h>c}function h(a){var b,c=s.getSet(a),d=!1;"pending"!==c&&(d=r,c&&(b=s.setRes(c),s.applySetCandidate(b,a))),a[s.ns].evaled=d}function i(a,b){return a.res-b.res}function j(a,b,c){var d;return!c&&b&&(c=a[s.ns].sets,c=c&&c[c.length-1]),d=k(b,c),d&&(b=s.makeUrl(b),a[s.ns].curSrc=b,a[s.ns].curCan=d,d.res||aa(d,d.set.sizes)),d}function k(a,b){var c,d,e;if(a&&b)for(e=s.parseSet(b),a=s.makeUrl(a),c=0;c<e.length;c++)if(a===s.makeUrl(e[c].url)){d=e[c];break}return d}function l(a,b){var c,d,e,f,g=a.getElementsByTagName("source");for(c=0,d=g.length;d>c;c++)e=g[c],e[s.ns]=!0,f=e.getAttribute("srcset"),f&&b.push({srcset:f,media:e.getAttribute("media"),type:e.getAttribute("type"),sizes:e.getAttribute("sizes")})}function m(a,b){function c(b){var c,d=b.exec(a.substring(m));return d?(c=d[0],m+=c.length,c):void 0}function e(){var a,c,d,e,f,i,j,k,l,m=!1,o={};for(e=0;e<h.length;e++)f=h[e],i=f[f.length-1],j=f.substring(0,f.length-1),k=parseInt(j,10),l=parseFloat(j),X.test(j)&&"w"===i?((a||c)&&(m=!0),0===k?m=!0:a=k):Y.test(j)&&"x"===i?((a||c||d)&&(m=!0),0>l?m=!0:c=l):X.test(j)&&"h"===i?((d||c)&&(m=!0),0===k?m=!0:d=k):m=!0;m||(o.url=g,a&&(o.w=a),c&&(o.d=c),d&&(o.h=d),d||c||a||(o.d=1),1===o.d&&(b.has1x=!0),o.set=b,n.push(o))}function f(){for(c(T),i="",j="in descriptor";;){if(k=a.charAt(m),"in descriptor"===j)if(d(k))i&&(h.push(i),i="",j="after descriptor");else{if(","===k)return m+=1,i&&h.push(i),void e();if("("===k)i+=k,j="in parens";else{if(""===k)return i&&h.push(i),void e();i+=k}}else if("in parens"===j)if(")"===k)i+=k,j="in descriptor";else{if(""===k)return h.push(i),void e();i+=k}else if("after descriptor"===j)if(d(k));else{if(""===k)return void e();j="in descriptor",m-=1}m+=1}}for(var g,h,i,j,k,l=a.length,m=0,n=[];;){if(c(U),m>=l)return n;g=c(V),h=[],","===g.slice(-1)?(g=g.replace(W,""),e()):f()}}function n(a){function b(a){function b(){f&&(g.push(f),f="")}function c(){g[0]&&(h.push(g),g=[])}for(var e,f="",g=[],h=[],i=0,j=0,k=!1;;){if(e=a.charAt(j),""===e)return b(),c(),h;if(k){if("*"===e&&"/"===a[j+1]){k=!1,j+=2,b();continue}j+=1}else{if(d(e)){if(a.charAt(j-1)&&d(a.charAt(j-1))||!f){j+=1;continue}if(0===i){b(),j+=1;continue}e=" "}else if("("===e)i+=1;else if(")"===e)i-=1;else{if(","===e){b(),c(),j+=1;continue}if("/"===e&&"*"===a.charAt(j+1)){k=!0,j+=2;continue}}f+=e,j+=1}}}function c(a){return k.test(a)&&parseFloat(a)>=0?!0:l.test(a)?!0:"0"===a||"-0"===a||"+0"===a?!0:!1}var e,f,g,h,i,j,k=/^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i,l=/^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;for(f=b(a),g=f.length,e=0;g>e;e++)if(h=f[e],i=h[h.length-1],c(i)){if(j=i,h.pop(),0===h.length)return j;if(h=h.join(" "),s.matchesMedia(h))return j}return"100vw"}b.createElement("picture");var o,p,q,r,s={},t=!1,u=function(){},v=b.createElement("img"),w=v.getAttribute,x=v.setAttribute,y=v.removeAttribute,z=b.documentElement,A={},B={algorithm:""},C="data-pfsrc",D=C+"set",E=navigator.userAgent,F=/rident/.test(E)||/ecko/.test(E)&&E.match(/rv\:(\d+)/)&&RegExp.$1>35,G="currentSrc",H=/\s+\+?\d+(e\d+)?w/,I=/(\([^)]+\))?\s*(.+)/,J=a.picturefillCFG,K="position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)",L="font-size:100%!important;",M=!0,N={},O={},P=a.devicePixelRatio,Q={px:1,"in":96},R=b.createElement("a"),S=!1,T=/^[ \t\n\r\u000c]+/,U=/^[, \t\n\r\u000c]+/,V=/^[^ \t\n\r\u000c]+/,W=/[,]+$/,X=/^\d+$/,Y=/^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,Z=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d||!1):a.attachEvent&&a.attachEvent("on"+b,c)},$=function(a){var b={};return function(c){return c in b||(b[c]=a(c)),b[c]}},_=function(){var a=/^([\d\.]+)(em|vw|px)$/,b=function(){for(var a=arguments,b=0,c=a[0];++b in a;)c=c.replace(a[b],a[++b]);return c},c=$(function(a){return"return "+b((a||"").toLowerCase(),/\band\b/g,"&&",/,/g,"||",/min-([a-z-\s]+):/g,"e.$1>=",/max-([a-z-\s]+):/g,"e.$1<=",/calc([^)]+)/g,"($1)",/(\d+[\.]*[\d]*)([a-z]+)/g,"($1 * e.$2)",/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi,"")+";"});return function(b,d){var e;if(!(b in N))if(N[b]=!1,d&&(e=b.match(a)))N[b]=e[1]*Q[e[2]];else try{N[b]=new Function("e",c(b))(Q)}catch(f){}return N[b]}}(),aa=function(a,b){return a.w?(a.cWidth=s.calcListLength(b||"100vw"),a.res=a.w/a.cWidth):a.res=a.d,a},ba=function(a){if(t){var c,d,e,f=a||{};if(f.elements&&1===f.elements.nodeType&&("IMG"===f.elements.nodeName.toUpperCase()?f.elements=[f.elements]:(f.context=f.elements,f.elements=null)),c=f.elements||s.qsa(f.context||b,f.reevaluate||f.reselect?s.sel:s.selShort),e=c.length){for(s.setupRun(f),S=!0,d=0;e>d;d++)s.fillImg(c[d],f);s.teardownRun(f)}}};o=a.console&&console.warn?function(a){console.warn(a)}:u,G in v||(G="src"),A["image/jpeg"]=!0,A["image/gif"]=!0,A["image/png"]=!0,A["image/svg+xml"]=b.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image","1.1"),s.ns=("pf"+(new Date).getTime()).substr(0,9),s.supSrcset="srcset"in v,s.supSizes="sizes"in v,s.supPicture=!!a.HTMLPictureElement,s.supSrcset&&s.supPicture&&!s.supSizes&&!function(a){v.srcset="data:,a",a.src="data:,a",s.supSrcset=v.complete===a.complete,s.supPicture=s.supSrcset&&s.supPicture}(b.createElement("img")),s.supSrcset&&!s.supSizes?!function(){var a="data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==",c="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",d=b.createElement("img"),e=function(){var a=d.width;2===a&&(s.supSizes=!0),q=s.supSrcset&&!s.supSizes,t=!0,setTimeout(ba)};d.onload=e,d.onerror=e,d.setAttribute("sizes","9px"),d.srcset=c+" 1w,"+a+" 9w",d.src=c}():t=!0,s.selShort="picture>img,img[srcset]",s.sel=s.selShort,s.cfg=B,s.DPR=P||1,s.u=Q,s.types=A,s.setSize=u,s.makeUrl=$(function(a){return R.href=a,R.href}),s.qsa=function(a,b){return"querySelector"in a?a.querySelectorAll(b):[]},s.matchesMedia=function(){return a.matchMedia&&(matchMedia("(min-width: 0.1em)")||{}).matches?s.matchesMedia=function(a){return!a||matchMedia(a).matches}:s.matchesMedia=s.mMQ,s.matchesMedia.apply(this,arguments)},s.mMQ=function(a){return a?_(a):!0},s.calcLength=function(a){var b=_(a,!0)||!1;return 0>b&&(b=!1),b},s.supportsType=function(a){return a?A[a]:!0},s.parseSize=$(function(a){var b=(a||"").match(I);return{media:b&&b[1],length:b&&b[2]}}),s.parseSet=function(a){return a.cands||(a.cands=m(a.srcset,a)),a.cands},s.getEmValue=function(){var a;if(!p&&(a=b.body)){var c=b.createElement("div"),d=z.style.cssText,e=a.style.cssText;c.style.cssText=K,z.style.cssText=L,a.style.cssText=L,a.appendChild(c),p=c.offsetWidth,a.removeChild(c),p=parseFloat(p,10),z.style.cssText=d,a.style.cssText=e}return p||16},s.calcListLength=function(a){if(!(a in O)||B.uT){var b=s.calcLength(n(a));O[a]=b?b:Q.width}return O[a]},s.setRes=function(a){var b;if(a){b=s.parseSet(a);for(var c=0,d=b.length;d>c;c++)aa(b[c],a.sizes)}return b},s.setRes.res=aa,s.applySetCandidate=function(a,b){if(a.length){var c,d,e,f,h,k,l,m,n,o=b[s.ns],p=s.DPR;if(k=o.curSrc||b[G],l=o.curCan||j(b,k,a[0].set),l&&l.set===a[0].set&&(n=F&&!b.complete&&l.res-.1>p,n||(l.cached=!0,l.res>=p&&(h=l))),!h)for(a.sort(i),f=a.length,h=a[f-1],d=0;f>d;d++)if(c=a[d],c.res>=p){e=d-1,h=a[e]&&(n||k!==s.makeUrl(c.url))&&g(a[e].res,c.res,p,a[e].cached)?a[e]:c;break}h&&(m=s.makeUrl(h.url),o.curSrc=m,o.curCan=h,m!==k&&s.setSrc(b,h),s.setSize(b))}},s.setSrc=function(a,b){var c;a.src=b.url,"image/svg+xml"===b.set.type&&(c=a.style.width,a.style.width=a.offsetWidth+1+"px",a.offsetWidth+1&&(a.style.width=c))},s.getSet=function(a){var b,c,d,e=!1,f=a[s.ns].sets;for(b=0;b<f.length&&!e;b++)if(c=f[b],c.srcset&&s.matchesMedia(c.media)&&(d=s.supportsType(c.type))){"pending"===d&&(c=d),e=c;break}return e},s.parseSets=function(a,b,d){var e,f,g,h,i=b&&"PICTURE"===b.nodeName.toUpperCase(),j=a[s.ns];(j.src===c||d.src)&&(j.src=w.call(a,"src"),j.src?x.call(a,C,j.src):y.call(a,C)),(j.srcset===c||d.srcset||!s.supSrcset||a.srcset)&&(e=w.call(a,"srcset"),j.srcset=e,h=!0),j.sets=[],i&&(j.pic=!0,l(b,j.sets)),j.srcset?(f={srcset:j.srcset,sizes:w.call(a,"sizes")},j.sets.push(f),g=(q||j.src)&&H.test(j.srcset||""),g||!j.src||k(j.src,f)||f.has1x||(f.srcset+=", "+j.src,f.cands.push({url:j.src,d:1,set:f}))):j.src&&j.sets.push({srcset:j.src,sizes:null}),j.curCan=null,j.curSrc=c,j.supported=!(i||f&&!s.supSrcset||g&&!s.supSizes),h&&s.supSrcset&&!j.supported&&(e?(x.call(a,D,e),a.srcset=""):y.call(a,D)),j.supported&&!j.srcset&&(!j.src&&a.src||a.src!==s.makeUrl(j.src))&&(null===j.src?a.removeAttribute("src"):a.src=j.src),j.parsed=!0},s.fillImg=function(a,b){var c,d=b.reselect||b.reevaluate;a[s.ns]||(a[s.ns]={}),c=a[s.ns],(d||c.evaled!==r)&&((!c.parsed||b.reevaluate)&&s.parseSets(a,a.parentNode,b),c.supported?c.evaled=r:h(a))},s.setupRun=function(){(!S||M||P!==a.devicePixelRatio)&&f()},s.supPicture?(ba=u,s.fillImg=u):!function(){var c,d=a.attachEvent?/d$|^c/:/d$|^c|^i/,e=function(){var a=b.readyState||"";f=setTimeout(e,"loading"===a?200:999),b.body&&(s.fillImgs(),c=c||d.test(a),c&&clearTimeout(f))},f=setTimeout(e,b.body?9:99),g=function(a,b){var c,d,e=function(){var f=new Date-d;b>f?c=setTimeout(e,b-f):(c=null,a())};return function(){d=new Date,c||(c=setTimeout(e,b))}},h=z.clientHeight,i=function(){M=Math.max(a.innerWidth||0,z.clientWidth)!==Q.width||z.clientHeight!==h,h=z.clientHeight,M&&s.fillImgs()};Z(a,"resize",g(i,99)),Z(b,"readystatechange",e)}(),s.picturefill=ba,s.fillImgs=ba,s.teardownRun=u,ba._=s,a.picturefillCFG={pf:s,push:function(a){var b=a.shift();"function"==typeof s[b]?s[b].apply(s,a):(B[b]=a[0],S&&s.fillImgs({reselect:!0}))}};for(;J&&J.length;)a.picturefillCFG.push(J.shift());a.picturefill=ba,"object"==typeof module&&"object"==typeof module.exports?module.exports=ba:"function"==typeof define&&define.amd&&define("picturefill",function(){return ba}),s.supPicture||(A["image/webp"]=e("image/webp","data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="))}(window,document);
/**
 * Minified by jsDelivr using Terser v5.3.5.
 * Original file: /npm/intersection-observer@0.12.0/intersection-observer.js
 */
!function(){"use strict";if("object"==typeof window)if("IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype)"isIntersecting"in window.IntersectionObserverEntry.prototype||Object.defineProperty(window.IntersectionObserverEntry.prototype,"isIntersecting",{get:function(){return this.intersectionRatio>0}});else{var t=function(t){for(var e=window.document,o=i(e);o;)o=i(e=o.ownerDocument);return e}(),e=[],o=null,n=null;s.prototype.THROTTLE_TIMEOUT=100,s.prototype.POLL_INTERVAL=null,s.prototype.USE_MUTATION_OBSERVER=!0,s._setupCrossOriginUpdater=function(){return o||(o=function(t,o){n=t&&o?l(t,o):{top:0,bottom:0,left:0,right:0,width:0,height:0},e.forEach((function(t){t._checkForIntersections()}))}),o},s._resetCrossOriginUpdater=function(){o=null,n=null},s.prototype.observe=function(t){if(!this._observationTargets.some((function(e){return e.element==t}))){if(!t||1!=t.nodeType)throw new Error("target must be an Element");this._registerInstance(),this._observationTargets.push({element:t,entry:null}),this._monitorIntersections(t.ownerDocument),this._checkForIntersections()}},s.prototype.unobserve=function(t){this._observationTargets=this._observationTargets.filter((function(e){return e.element!=t})),this._unmonitorIntersections(t.ownerDocument),0==this._observationTargets.length&&this._unregisterInstance()},s.prototype.disconnect=function(){this._observationTargets=[],this._unmonitorAllIntersections(),this._unregisterInstance()},s.prototype.takeRecords=function(){var t=this._queuedEntries.slice();return this._queuedEntries=[],t},s.prototype._initThresholds=function(t){var e=t||[0];return Array.isArray(e)||(e=[e]),e.sort().filter((function(t,e,o){if("number"!=typeof t||isNaN(t)||t<0||t>1)throw new Error("threshold must be a number between 0 and 1 inclusively");return t!==o[e-1]}))},s.prototype._parseRootMargin=function(t){var e=(t||"0px").split(/\s+/).map((function(t){var e=/^(-?\d*\.?\d+)(px|%)$/.exec(t);if(!e)throw new Error("rootMargin must be specified in pixels or percent");return{value:parseFloat(e[1]),unit:e[2]}}));return e[1]=e[1]||e[0],e[2]=e[2]||e[0],e[3]=e[3]||e[1],e},s.prototype._monitorIntersections=function(e){var o=e.defaultView;if(o&&-1==this._monitoringDocuments.indexOf(e)){var n=this._checkForIntersections,r=null,s=null;this.POLL_INTERVAL?r=o.setInterval(n,this.POLL_INTERVAL):(h(o,"resize",n,!0),h(e,"scroll",n,!0),this.USE_MUTATION_OBSERVER&&"MutationObserver"in o&&(s=new o.MutationObserver(n)).observe(e,{attributes:!0,childList:!0,characterData:!0,subtree:!0})),this._monitoringDocuments.push(e),this._monitoringUnsubscribes.push((function(){var t=e.defaultView;t&&(r&&t.clearInterval(r),c(t,"resize",n,!0)),c(e,"scroll",n,!0),s&&s.disconnect()}));var u=this.root&&(this.root.ownerDocument||this.root)||t;if(e!=u){var a=i(e);a&&this._monitorIntersections(a.ownerDocument)}}},s.prototype._unmonitorIntersections=function(e){var o=this._monitoringDocuments.indexOf(e);if(-1!=o){var n=this.root&&(this.root.ownerDocument||this.root)||t;if(!this._observationTargets.some((function(t){var o=t.element.ownerDocument;if(o==e)return!0;for(;o&&o!=n;){var r=i(o);if((o=r&&r.ownerDocument)==e)return!0}return!1}))){var r=this._monitoringUnsubscribes[o];if(this._monitoringDocuments.splice(o,1),this._monitoringUnsubscribes.splice(o,1),r(),e!=n){var s=i(e);s&&this._unmonitorIntersections(s.ownerDocument)}}}},s.prototype._unmonitorAllIntersections=function(){var t=this._monitoringUnsubscribes.slice(0);this._monitoringDocuments.length=0,this._monitoringUnsubscribes.length=0;for(var e=0;e<t.length;e++)t[e]()},s.prototype._checkForIntersections=function(){if(this.root||!o||n){var t=this._rootIsInDom(),e=t?this._getRootRect():{top:0,bottom:0,left:0,right:0,width:0,height:0};this._observationTargets.forEach((function(n){var i=n.element,s=u(i),h=this._rootContainsTarget(i),c=n.entry,a=t&&h&&this._computeTargetAndRootIntersection(i,s,e),l=null;this._rootContainsTarget(i)?o&&!this.root||(l=e):l={top:0,bottom:0,left:0,right:0,width:0,height:0};var f=n.entry=new r({time:window.performance&&performance.now&&performance.now(),target:i,boundingClientRect:s,rootBounds:l,intersectionRect:a});c?t&&h?this._hasCrossedThreshold(c,f)&&this._queuedEntries.push(f):c&&c.isIntersecting&&this._queuedEntries.push(f):this._queuedEntries.push(f)}),this),this._queuedEntries.length&&this._callback(this.takeRecords(),this)}},s.prototype._computeTargetAndRootIntersection=function(e,i,r){if("none"!=window.getComputedStyle(e).display){for(var s,h,c,a,f,d,g,m,v=i,_=p(e),b=!1;!b&&_;){var w=null,y=1==_.nodeType?window.getComputedStyle(_):{};if("none"==y.display)return null;if(_==this.root||9==_.nodeType)if(b=!0,_==this.root||_==t)o&&!this.root?!n||0==n.width&&0==n.height?(_=null,w=null,v=null):w=n:w=r;else{var I=p(_),E=I&&u(I),T=I&&this._computeTargetAndRootIntersection(I,E,r);E&&T?(_=I,w=l(E,T)):(_=null,v=null)}else{var R=_.ownerDocument;_!=R.body&&_!=R.documentElement&&"visible"!=y.overflow&&(w=u(_))}if(w&&(s=w,h=v,c=void 0,a=void 0,f=void 0,d=void 0,g=void 0,m=void 0,c=Math.max(s.top,h.top),a=Math.min(s.bottom,h.bottom),f=Math.max(s.left,h.left),d=Math.min(s.right,h.right),m=a-c,v=(g=d-f)>=0&&m>=0&&{top:c,bottom:a,left:f,right:d,width:g,height:m}||null),!v)break;_=_&&p(_)}return v}},s.prototype._getRootRect=function(){var e;if(this.root&&!d(this.root))e=u(this.root);else{var o=d(this.root)?this.root:t,n=o.documentElement,i=o.body;e={top:0,left:0,right:n.clientWidth||i.clientWidth,width:n.clientWidth||i.clientWidth,bottom:n.clientHeight||i.clientHeight,height:n.clientHeight||i.clientHeight}}return this._expandRectByRootMargin(e)},s.prototype._expandRectByRootMargin=function(t){var e=this._rootMarginValues.map((function(e,o){return"px"==e.unit?e.value:e.value*(o%2?t.width:t.height)/100})),o={top:t.top-e[0],right:t.right+e[1],bottom:t.bottom+e[2],left:t.left-e[3]};return o.width=o.right-o.left,o.height=o.bottom-o.top,o},s.prototype._hasCrossedThreshold=function(t,e){var o=t&&t.isIntersecting?t.intersectionRatio||0:-1,n=e.isIntersecting?e.intersectionRatio||0:-1;if(o!==n)for(var i=0;i<this.thresholds.length;i++){var r=this.thresholds[i];if(r==o||r==n||r<o!=r<n)return!0}},s.prototype._rootIsInDom=function(){return!this.root||f(t,this.root)},s.prototype._rootContainsTarget=function(e){var o=this.root&&(this.root.ownerDocument||this.root)||t;return f(o,e)&&(!this.root||o==e.ownerDocument)},s.prototype._registerInstance=function(){e.indexOf(this)<0&&e.push(this)},s.prototype._unregisterInstance=function(){var t=e.indexOf(this);-1!=t&&e.splice(t,1)},window.IntersectionObserver=s,window.IntersectionObserverEntry=r}function i(t){try{return t.defaultView&&t.defaultView.frameElement||null}catch(t){return null}}function r(t){this.time=t.time,this.target=t.target,this.rootBounds=a(t.rootBounds),this.boundingClientRect=a(t.boundingClientRect),this.intersectionRect=a(t.intersectionRect||{top:0,bottom:0,left:0,right:0,width:0,height:0}),this.isIntersecting=!!t.intersectionRect;var e=this.boundingClientRect,o=e.width*e.height,n=this.intersectionRect,i=n.width*n.height;this.intersectionRatio=o?Number((i/o).toFixed(4)):this.isIntersecting?1:0}function s(t,e){var o,n,i,r=e||{};if("function"!=typeof t)throw new Error("callback must be a function");if(r.root&&1!=r.root.nodeType&&9!=r.root.nodeType)throw new Error("root must be a Document or Element");this._checkForIntersections=(o=this._checkForIntersections.bind(this),n=this.THROTTLE_TIMEOUT,i=null,function(){i||(i=setTimeout((function(){o(),i=null}),n))}),this._callback=t,this._observationTargets=[],this._queuedEntries=[],this._rootMarginValues=this._parseRootMargin(r.rootMargin),this.thresholds=this._initThresholds(r.threshold),this.root=r.root||null,this.rootMargin=this._rootMarginValues.map((function(t){return t.value+t.unit})).join(" "),this._monitoringDocuments=[],this._monitoringUnsubscribes=[]}function h(t,e,o,n){"function"==typeof t.addEventListener?t.addEventListener(e,o,n||!1):"function"==typeof t.attachEvent&&t.attachEvent("on"+e,o)}function c(t,e,o,n){"function"==typeof t.removeEventListener?t.removeEventListener(e,o,n||!1):"function"==typeof t.detatchEvent&&t.detatchEvent("on"+e,o)}function u(t){var e;try{e=t.getBoundingClientRect()}catch(t){}return e?(e.width&&e.height||(e={top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:e.right-e.left,height:e.bottom-e.top}),e):{top:0,bottom:0,left:0,right:0,width:0,height:0}}function a(t){return!t||"x"in t?t:{top:t.top,y:t.top,bottom:t.bottom,left:t.left,x:t.left,right:t.right,width:t.width,height:t.height}}function l(t,e){var o=e.top-t.top,n=e.left-t.left;return{top:o,left:n,height:e.height,width:e.width,bottom:o+e.height,right:n+e.width}}function f(t,e){for(var o=e;o;){if(o==t)return!0;o=p(o)}return!1}function p(e){var o=e.parentNode;return 9==e.nodeType&&e!=t?i(e):(o&&o.assignedSlot&&(o=o.assignedSlot.parentNode),o&&11==o.nodeType&&o.host?o.host:o)}function d(t){return t&&9===t.nodeType}}();
/*!
  * Stickyfill – `position: sticky` polyfill
  * v. 2.1.0 | https://github.com/wilddeer/stickyfill
  * MIT License
  */
!function(a,b){"use strict";function c(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function d(a,b){for(var c in b)b.hasOwnProperty(c)&&(a[c]=b[c])}function e(a){return parseFloat(a)||0}function f(a){for(var b=0;a;)b+=a.offsetTop,a=a.offsetParent;return b}function g(){function c(){a.pageXOffset!=m.left?(m.top=a.pageYOffset,m.left=a.pageXOffset,p.refreshAll()):a.pageYOffset!=m.top&&(m.top=a.pageYOffset,m.left=a.pageXOffset,n.forEach(function(a){return a._recalcPosition()}))}function d(){f=setInterval(function(){n.forEach(function(a){return a._fastCheck()})},500)}function e(){clearInterval(f)}if(!k){k=!0,c(),a.addEventListener("scroll",c),a.addEventListener("resize",p.refreshAll),a.addEventListener("orientationchange",p.refreshAll);var f=void 0,g=void 0,h=void 0;"hidden"in b?(g="hidden",h="visibilitychange"):"webkitHidden"in b&&(g="webkitHidden",h="webkitvisibilitychange"),h?(b[g]||d(),b.addEventListener(h,function(){b[g]?e():d()})):d()}}var h=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),i=!1,j="undefined"!=typeof a;j&&a.getComputedStyle?!function(){var a=b.createElement("div");["","-webkit-","-moz-","-ms-"].some(function(b){try{a.style.position=b+"sticky"}catch(a){}return""!=a.style.position})&&(i=!0)}():i=!0;var k=!1,l="undefined"!=typeof ShadowRoot,m={top:null,left:null},n=[],o=function(){function g(a){if(c(this,g),!(a instanceof HTMLElement))throw new Error("First argument must be HTMLElement");if(n.some(function(b){return b._node===a}))throw new Error("Stickyfill is already applied to this node");this._node=a,this._stickyMode=null,this._active=!1,n.push(this),this.refresh()}return h(g,[{key:"refresh",value:function(){if(!i&&!this._removed){this._active&&this._deactivate();var c=this._node,g=getComputedStyle(c),h={position:g.position,top:g.top,display:g.display,marginTop:g.marginTop,marginBottom:g.marginBottom,marginLeft:g.marginLeft,marginRight:g.marginRight,cssFloat:g.cssFloat};if(!isNaN(parseFloat(h.top))&&"table-cell"!=h.display&&"none"!=h.display){this._active=!0;var j=c.style.position;"sticky"!=g.position&&"-webkit-sticky"!=g.position||(c.style.position="static");var k=c.parentNode,m=l&&k instanceof ShadowRoot?k.host:k,n=c.getBoundingClientRect(),o=m.getBoundingClientRect(),p=getComputedStyle(m);this._parent={node:m,styles:{position:m.style.position},offsetHeight:m.offsetHeight},this._offsetToWindow={left:n.left,right:b.documentElement.clientWidth-n.right},this._offsetToParent={top:n.top-o.top-e(p.borderTopWidth),left:n.left-o.left-e(p.borderLeftWidth),right:-n.right+o.right-e(p.borderRightWidth)},this._styles={position:j,top:c.style.top,bottom:c.style.bottom,left:c.style.left,right:c.style.right,width:c.style.width,marginTop:c.style.marginTop,marginLeft:c.style.marginLeft,marginRight:c.style.marginRight};var q=e(h.top);this._limits={start:n.top+a.pageYOffset-q,end:o.top+a.pageYOffset+m.offsetHeight-e(p.borderBottomWidth)-c.offsetHeight-q-e(h.marginBottom)};var r=p.position;"absolute"!=r&&"relative"!=r&&(m.style.position="relative"),this._recalcPosition();var s=this._clone={};s.node=b.createElement("div"),d(s.node.style,{width:n.right-n.left+"px",height:n.bottom-n.top+"px",marginTop:h.marginTop,marginBottom:h.marginBottom,marginLeft:h.marginLeft,marginRight:h.marginRight,cssFloat:h.cssFloat,padding:0,border:0,borderSpacing:0,fontSize:"1em",position:"static"}),k.insertBefore(s.node,c),s.docOffsetTop=f(s.node)}}}},{key:"_recalcPosition",value:function(){if(this._active&&!this._removed){var a=m.top<=this._limits.start?"start":m.top>=this._limits.end?"end":"middle";if(this._stickyMode!=a){switch(a){case"start":d(this._node.style,{position:"absolute",left:this._offsetToParent.left+"px",right:this._offsetToParent.right+"px",top:this._offsetToParent.top+"px",bottom:"auto",width:"auto",marginLeft:0,marginRight:0,marginTop:0});break;case"middle":d(this._node.style,{position:"fixed",left:this._offsetToWindow.left+"px",right:this._offsetToWindow.right+"px",top:this._styles.top,bottom:"auto",width:"auto",marginLeft:0,marginRight:0,marginTop:0});break;case"end":d(this._node.style,{position:"absolute",left:this._offsetToParent.left+"px",right:this._offsetToParent.right+"px",top:"auto",bottom:0,width:"auto",marginLeft:0,marginRight:0})}this._stickyMode=a}}}},{key:"_fastCheck",value:function(){this._active&&!this._removed&&(Math.abs(f(this._clone.node)-this._clone.docOffsetTop)>1||Math.abs(this._parent.node.offsetHeight-this._parent.offsetHeight)>1)&&this.refresh()}},{key:"_deactivate",value:function(){var a=this;this._active&&!this._removed&&(this._clone.node.parentNode.removeChild(this._clone.node),delete this._clone,d(this._node.style,this._styles),delete this._styles,n.some(function(b){return b!==a&&b._parent&&b._parent.node===a._parent.node})||d(this._parent.node.style,this._parent.styles),delete this._parent,this._stickyMode=null,this._active=!1,delete this._offsetToWindow,delete this._offsetToParent,delete this._limits)}},{key:"remove",value:function(){var a=this;this._deactivate(),n.some(function(b,c){if(b._node===a._node)return n.splice(c,1),!0}),this._removed=!0}}]),g}(),p={stickies:n,Sticky:o,forceSticky:function(){i=!1,g(),this.refreshAll()},addOne:function(a){if(!(a instanceof HTMLElement)){if(!a.length||!a[0])return;a=a[0]}for(var b=0;b<n.length;b++)if(n[b]._node===a)return n[b];return new o(a)},add:function(a){if(a instanceof HTMLElement&&(a=[a]),a.length){for(var b=[],c=function(c){var d=a[c];return d instanceof HTMLElement?n.some(function(a){if(a._node===d)return b.push(a),!0})?"continue":void b.push(new o(d)):(b.push(void 0),"continue")},d=0;d<a.length;d++){c(d)}return b}},refreshAll:function(){n.forEach(function(a){return a.refresh()})},removeOne:function(a){if(!(a instanceof HTMLElement)){if(!a.length||!a[0])return;a=a[0]}n.some(function(b){if(b._node===a)return b.remove(),!0})},remove:function(a){if(a instanceof HTMLElement&&(a=[a]),a.length)for(var b=function(b){var c=a[b];n.some(function(a){if(a._node===c)return a.remove(),!0})},c=0;c<a.length;c++)b(c)},removeAll:function(){for(;n.length;)n[0].remove()}};i||g(),"undefined"!=typeof module&&module.exports?module.exports=p:j&&(a.Stickyfill=p)}(window,document);

/** Polyfill
 * for CSS object-fit/object-position
 * 
 * https://github.com/fregante/object-fit-images 
 * 已實測可 IE11
 * 內建支援<picture> + object-fit/object-position 則不作動: Edge 89 Mac, Chrome, Safari 10.1, Firefox 87
 * 
 **************************/
$(function(){
	objectFitImages(null,{ 
		watchMQ: true,
		skipTest: false //非必要不可設true，會使內建支援的browser watchMQ失誤  
	});  
});  
 /** Dimension helpers */
 base.getPageY = function() { return window.pageYOffset || ((('clientHeight' in document.documentElement))?document.documentElement:document.body).scrollTop; };
 base.getWinW = function() { return window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth||$(window).width(); };
 base.getWinH = function() { var h = window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight||$(window).height(); return h; };
 
 /** Touch device
  */
 base.isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
 if(base.isTouch) {
 	document.documentElement.className = document.documentElement.className + ' touch';
 } else {
 	document.documentElement.className = document.documentElement.className + ' no-touch';
 }
 
 /** Avoid touchmove event propagating from scrollable child (overflow:scroll) to window.
  * Support touch device only
  * and can't be tested on Chrome developer simulator.
  * 
  * @see https://github.com/lazd/iNoBounce
  * @version 20191220 
  */
 $.fn.blockTouchmove = function(exclude) {
 	return this.each(function(){
 		this.btm = this.btm || {};
 		$(this)
 			.off('touchstart.btm touchmove.btm')
 			.on('touchstart.btm', function(e) {
 				this.btm_y = e.originalEvent.touches ? e.originalEvent.touches[0].screenY : e.originalEvent.screenY;
 			})
 			.on('touchmove.btm', function(e) {
 				if(exclude!=undefined && $(exclude).find(e.target)[0]) {
 					return true;
 				}
 				if(this.scrollHeight > this.offsetHeight) {
 					var y = e.originalEvent.touches ? e.originalEvent.touches[0].screenY : e.originalEvent.screenY;
 					var atTop = (this.btm_y <= y && this.scrollTop <= 0);
 					var atBottom = (this.btm_y >= y && this.scrollHeight - this.scrollTop <= /*this.offsetHeight*/$(this).innerHeight());
 	
 					if(atTop || atBottom) {
 						e.preventDefault();
 					}
 				}
 				else {
 					e.preventDefault();
 				}
 			});
 	});
 };
 
 
 /** 頁面scroll狀態
  * @version 20120803
  *************************/
 
 // Flag to tell if the change was programmatic or by the user
 base.ignoreNextScrollEvent = true;
 
 $(function() {
 	
 	//$(window).on('scroll resize orientationchange load touchmove', $.debounce(5, true, update));
 	$(window).on('scroll resize orientationchange load touchmove', update);
 	setTimeout(update, 31);
 	setTimeout(update, 300);
 	
 	var html = $('html'),
 		isFixed = html.hasClass('header--fixed'),
 		lastScrollY = 0,
 		scrollThreshold;
 		
 	html.addClass('scrolled-down');
 	
 	setTimeout(function(){
 		base.ignoreNextScrollEvent = false;
 	}, 2000);
 	
 	function update() {
 		var scrollY = base.getPageY(),
 			vh = base.getWinH(),
 			top = 10,
 			bottom = html.outerHeight() - vh - 60,
 			state;
 		
 		// Header 置頂狀態 
 		if(!isFixed) {
 			state = 'header--fixed';
 			
 			if(scrollY >= top && !html.hasClass(state)) {
 				html.addClass(state);
 			}
 			else if(scrollY < top && html.hasClass(state)) {
 				html.removeClass(state);
 			}
 		}
 		
 		// 頁面已scroll離開置頂
 		state = 'leave-top';
 		if(scrollY >= vh*.3) {
 			html.addClass(state, scrollY >= vh*.3 );
 			scrollThreshold = 25;
 		}
 		else {
 			html.removeClass(state, scrollY >= vh*.3 );
 			scrollThreshold = 6;
 		}
 		
 		
 		
 		// 往上捲動才出現header
 		if(!base.ignoreNextScrollEvent) {
 			if(scrollY < lastScrollY - scrollThreshold || scrollY <= 0) { // 往回(往上)捲
 				html.addClass('scrolled-up').removeClass('scrolled-down');
 			}
 			else if(scrollY > lastScrollY + scrollThreshold*.5){
 				html.addClass('scrolled-down').removeClass('scrolled-up');
 			}
 			lastScrollY = scrollY;
 		}
 		
 		
 		// 頁面已scroll到底狀態 	
 		state = 'reach-bottom';
 		
 		if(scrollY >= bottom && !html.hasClass(state)) {
 			html.addClass(state);
 			
 		}
 		else if(scrollY < bottom && html.hasClass(state)) {
 			html.removeClass(state);
 		}
 	}
 });
 
 
 /** PC .navbar under .homekv
  *  & global header
  *************************/
 $(function(){
 	var pageNavbar = $('.homekv .navbar');
 	
 	if(!pageNavbar[0] ||/* base.getWinW() < 1152 ||*/ !$('html').hasClass('header--hidden')) {
 		return;
 	}
 	
 	$(window).on('scroll resize orientationchange load touchmove', $.debounce(5, true, update));
 	
 	function update() {
 		var scrollY = base.getPageY(),
 			top = pageNavbar.offset().top + pageNavbar.height();
 		
 		$('html').toggleClass('header--hidden', scrollY <= top);
 	}
 });
 
 
 /** scrollTo element
  */
 base.scrollTo = (function(anchor) {
 	function _init() {
 		$(document).on('click', '[js-scrollTo]', function(e) {
 			scrollTo( $(this).attr('href') );
 			e.preventDefault();
 		});
 	}
 	
 	function scrollTo(target, opts) {
 		// Scroll to element
 		var el = $(target);
 		if(!el[0]) return;
 		
 		var y = el.offset().top,
 			dist = Math.abs(y - base.getPageY()),
 			opts = $.extend({
 						offset: 0,
 						duration: Math.round(Math.max( 500, dist*.5 )),
 						easing:'swing'
 					}, opts||{});
 		
 		// https://api.jquery.com/animate/
 		$('html,body').animate({
 			scrollTop: y + opts.offset
 		}, opts);
 	};
 	
 	$(_init);
 	return scrollTo;
 })();
 
 // Backtop event listener
 $(function() {
 	$('[js-backtop]').on('click', function(e){
 		base.scrollTo('html');
 		e.preventDefault();
 	});
 });
 
 
 // debug
 
 $(function(){
 	return;
 	$('.masthead').on('dblclick', function(){
 		$('html').toggleClass('debug');
 		$('.fluid').css('border-left', '1px solid red');
 		$('.fluid').css('border-right', '1px solid red');
 	});
 });

/** Fancybox defaults
 * https://fancyapps.com/fancybox/3/docs/#options
 *************************/
if($.fancybox) {
	$.fancybox.defaults.hash = false; // Disable hash change
	//$.fancybox.defaults.animationEffect = "fade";
	$.fancybox.defaults.animationDuration = 168; // Duration in ms for open/close animation
	$.fancybox.defaults.buttons = [ // What buttons should appear in the top right corner.
		//"zoom",
		//"share",
		//"slideShow", 
		"fullScreen",  
		"thumbs", 
		"close"
	];
	$.fancybox.defaults.btnTpl.arrowLeft =
		'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
			'<span class="btn-prev  btn-angle-prev"></span>'
		'</button>';
	$.fancybox.defaults.btnTpl.arrowRight =
		'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
			'<span class="btn-next  btn-angle-next"></span>'
		'</button>';
}


  
///////////////////////////  
//    Content            //
/////////////////////////// 
 
 /** Header & panel
  * 
  * [js-panel, [js-panel-btn]
  * base.openPanel
  * base.closePanel
  * 
  *************************/
 
 
 /** PC navigation
  *************************/
 $(function(){
 	
 	var	timer;
 	
 	// Mouse
 	if(!base.isTouch) {
 		
 		// pc主選單 [js-panel-btn] 
 		// 各自對應的 panel 子選單
 		$('.navbar [js-panel-btn]').on('mouseenter mouseleave click', function(e){
 			var el = this; 
 			switch(e.type) {
 				case 'mouseenter':
 					clearTimeout(timer);
 					timer = setTimeout(function(){
 						
 						toggleBtn(el, true);
 						
 						el.mouseDisabled = true;
 						timer = setTimeout(function(){ el.mouseDisabled = false; }, 350);
 					}, !base.activePanelId?150:1);
 					break;
 				
 				// 避免一離開按鈕 panel就關閉
 				case 'mouseleave':
 					delayClosePanel();
 					break;
 				
 				case 'click':
 					if(el.mouseDisabled) { return true; } // Avoid immediate click and close an opened panel
 					
 					toggleBtn(el);
 					break;
 			}
 		});
 		
 		$('.navbar').on('mouseleave', function(e){
 		});
 		
 		// 避免一離開按鈕 panel就關閉
 		$('[js-panel]').on('mouseenter', function(e){
 			clearTimeout(timer);
 		});
 		
 		// Mouse out 子選單
 		$('[js-panel^="subnav-"]').on('mouseleave', function(e){
 			delayClosePanel();
 		});
 		
 		// Mouse over 沒有子選單的主項關閉 active panel
 		/*$('.navbar-link').not('[js-panel-btn]').on('mouseenter', function(e){
 			delayClosePanel();
 		});*/
 	}
 	
 	// Touch
 	else {
 		$('.navbar [js-panel-btn]').on('click', function(e){
 			var el = this; 
 			switch(e.type) {
 				case 'click':
 					toggleBtn(el);
 					e.stopPropagation();
 					e.preventDefault();
 					break;
 			}
 		});
 	}
 	
 	
 	
 	function delayClosePanel() {
 		clearTimeout(timer);
 		timer = setTimeout(function(){
 			base.closePanel();
 		}, 300);
 	};
 	
 	function toggleBtn(el, forceOpen) {
 		var btn = $(el),
 			id = btn.attr('js-panel-btn');
 						
 		if(!btn.hasClass('opened') || forceOpen == true) { // revised @20210515
 			btn.addClass('opened');
 			
 			// Set subnav position
 			var panel = $('[js-panel="'+id+'"]');
 			var left = btn.parent().position().left - (panel.outerWidth() - btn.outerWidth() - 20)*.5;
 			panel.css({ left: left });
 			
 			base.openPanel(id, btn);
 			
 			panel.one('close', function(e) {
 				btn.removeClass('opened');
 			});
 		}
 		else {
 			btn.removeClass('opened');
 			base.closePanel();
 		}
 	};
 	
 });
 
 
 /** Mobile navigation
  *************************/
 $(function(){
 	// Hamburger button
 	$('.masthead-toggle').on('click', function(){
 		base.openPanel('mbpanel');
 	});
 	
 	// Status flag
 	$('[js-panel="mbpanel"]').on('open close', function(e){
 		$('html').toggleClass('mbpanel--open', e.type=='open');
 	});
 	
 	// Close button
 	$('.mbpanel-dismiss').on('click', function(e){
 		base.closePanel();
 	});
 	
 	// Animate out 
 	$('[js-panel="mbpanel"]').on('close', function(e){
 		$('[js-panel="mbpanel"]').addClass('animate-out');
 		setTimeout(function(){
 			$('[js-panel="mbpanel"]').removeClass('animate-out');
 			base.closePanel();
 		}, 250);
 	});
 	
 	// Avoid touchmove body content 
 	$('.mbpanel-col').blockTouchmove();
 	
 });
 
 
 /** Click anywhere to close panel
  *************************/ 
 $(function(){
 	document.documentElement.addEventListener(!base.isTouch?'click':'touchend', clickAnywhere, true); // Fire event on capturing phase
 	
 	function clickAnywhere(e) {
 		if($('.panel--active').length == 0) {
 			return true;
 		}
 		
 		//console.log('click anywhere', e.target.tagName.toUpperCase() + '.'+e.target.className.substr(10));
 		
 		if(!$('.masthead').find(e.target)[0] || $(e.target).is('[js-panel]')) {
 			base.closePanel();
 			e.stopPropagation();
 			e.stopImmediatePropagation();
 			return false;
 		}
 	}
 });
 
 
 /** Panel controller
  *************************/
 
 base.activePanelId = undefined;
 
 base.openPanel = function(id) {
 	var panel = $('[js-panel="'+id+'"]');
 	if(!panel[0]) { return false;}
 	
 	if(base.activePanelId == id) { 
 		//base.closePanel();
 		return;
 	}
 	
 	base.closePanel();
 	
 	base.activePanelId = id;
 	
 	//console.log('%c openPanel id= ' + base.activePanelId, 'font-weight:700;color:#fff;background:#24BCDC'); 
 	
 	panel.addClass('panel--active');
 	
 	panel.trigger('open');
 };
 	
 base.closePanel = function() {
 	var panel = $('.panel--active[js-panel]');
 	if(!panel[0]) { return false;}
 	
 	base.activePanelId = undefined;
 	
 	//console.log('%c closePanel '+ panel.attr('js-panel'), 'font-weight:700;color:#fff;background:#24BCDC'); 
 	
 	panel.removeClass('panel--active');
 	
 	panel.trigger('close');
 };
 
 
 	
 
 
 
/**
 * $.fn.swiperlist
 * Swiper 客製 
 * @version 20210802
 * 
 *	在HTML結構發生處綁定屬性 js-swiper-option 來自動生成 Swiper instance 並帶入功能設定，
 *	未綁定性 js-swiper-option，則必須從 js 手動建立 Swiper instance。
 *
 *	Swiper文件 https://swiperjs.com/
 *  js使用版本 v5.4.5 ( 需留意v5.3 or 最新版本有可能不支援部分option，勿更換版本)
 *  css使用本 v4.5.0
 *	
 *	HTML範例:
 *	<div class="swiper-container"
 *		js-swiper-option='{"off":"never", "xs":2.2, "sm":3, "md":3, "lg":4, "xl":5, "paginav":"001", "prevbtn":"001", "nextbtn":"001"}'>
 *
 *		<div class="swiper-wrapper">
 *			<div class="swiper-slide">...</div>
 *			<div class="swiper-slide">...</div>
 *			<div class="swiper-slide">...</div>
 *		</div>
 *		<div class="pagination-dot" js-swiper-paginav="001">分頁按鈕</div>
 *		<div js-swiper-nextbtn="001">下一頁(unstyled)</div>
*		<div js-swiper-prevbtn="001">上一頁(unstyled)</div>
 *	</div>
 *
 *	- 需留意 JSON 合法格式，屬性名稱要雙引號""，值為字串也要雙引號""
 *  - HTML結構綁定 .swiper-container, .swiper-wrapper, .swiper-slide
 *
 *
 *	$.fn.swiperlist 自創設定：
 *	
 *		- off =>  xs|sm|md|lg|xl|never,
 *				 設定RWD寬度 依序由小至大，當寬度大到多少「就不套用Swiper」回復正常HTML；
 *		 	     例如： mobile版面需要 Swiper，pc版面不需要Swiper，可設定為 "md"，預設 "never"代表永遠作動。
 *		 	     
 * 				 另外支援直接填入 Media Query 字串，例如： (max-width:768px)
 *		 	   
 *		- xs => auto|數值, 當RWD寬度 < 433px 每分頁可視item數，支援小數點； 若為"auto"，則忽略sm,md,lg,xl。
 *		- sm => 數值, RWD寬度 >= 433px
 *		- md => 數值, RWD寬度 >= 769px
 *		- lg => 數值, RWD寬度 >= 1153px
 *		- xl => 數值, RWD寬度 >= 1536px
 *
 *	- 以下非必填
 *		- nextbtn => 指定下一頁按鈕element <div js-swiper-nextbtn="名稱"> 不可與同頁面上的其他Swiper同名稱；
 *										若未提供此參數，則自動尋找 .swiper-container 內綁定 js-swiper-nextbtn 屬性者。
 *		- prevbtn => 指定上一頁按鈕element
 *		- paginav => 指定分頁按鈕elment
 *
 *	- 其餘 Swiper內建設定皆可傳入，詳見 Swiper文件，
 *	  例如：
 *		- loop
 *		- autoplay
 *		- autoHeight
 *		- freeMode
 *	
 *************************/
$.fn.swiperlist = function(instanceOptions) {
	if(!window.Swiper) { return this; } //@20210628
	
	// 由 js 建立的instance 帶入 options
	var instanceOptions = instanceOptions || {};
	
	// Defaults options
	var basicOptions  = {
		// https://swiperjs.com/swiper-api#parameters
		init			: true,
		autoHeight		: true,
		loop			: false,
		slidesPerView	: 1,
		spaceBetween	: 0,
		threshold		: 3,
		autoplay		: { disableOnInteraction: false },
		pagination		: {
			el: null,
			type: 'bullets',
			clickable: true,
			renderBullet: function (index, className) {
				return '<span class="' + className + '">' + (index + 1) + '</span>';
			}
		},
		watchOverflow	: false, //When enabled Swiper will be disabled and hide navigation buttons on case there are not enough slides for sliding.
		observer		: true,
		observeParents	: true,
		preventInteractionOnTransition: false
	};
	
	
	var io; 
	if('IntersectionObserver' in window){
		io = new IntersectionObserver(intersect);
	}
	
	return this.each(function() {
		
		var o = this;
		
		if(!!o.swiper) { return true; }
		
		
		// HTML 綁定 js-swiper-option 傳入的 options 
		var paramData = $(o).attr('js-swiper-option');
		var paramOptions = { off: instanceOptions.off || 'never' };
		
		try {
			paramData = JSON.parse(paramData);
		} catch (e) {}
		
		if(!!paramData) {
			
			// 複製 js-swiper-option
			$.extend(true, paramOptions, paramData);
			
			// 處理 js-swiper-option
			
			// xs - 決定每頁可視item數 (slidesPerView, slidesPerGroup)
			// xs 為'auto'
			if(paramData.xs == 'auto') {
				$.extend(true, paramOptions, { slidesPerView:'auto' });
			}
			
			// xs,sm,md,lg,xl 依 RWD 寬度帶入每個 breakpoints.slidesPerView 數值
			else {
				// 若沒有傳入 xs 則取 slidePerView
				var num = parseFloat(paramData.xs || paramData.slidesPerView || basicOptions.slidesPerView);
				
				$.extend(true, paramOptions, { slidesPerView: num, slidesPerGroup: Math.floor(num) });
				
				
				num = parseFloat(paramData.sm || num);
				if(!!num) {
					$.extend(true, paramOptions, { breakpoints: { 433: { slidesPerView: num, slidesPerGroup: Math.floor(num) }}});
				}
				num = parseFloat(paramData.md || num);
				if(!!num) {
					$.extend(true, paramOptions, { breakpoints: { 769: { slidesPerView: num, slidesPerGroup: Math.floor(num) }}});
				}
				num = parseFloat(paramData.lg || num);
				if(!!num) {
					$.extend(true, paramOptions, { breakpoints: { 1153: { slidesPerView: num, slidesPerGroup: Math.floor(num) }}});
				}
				num = parseFloat(paramData.xl || num);
				if(!!num) {
					$.extend(true, paramOptions, { breakpoints: { 1537: { slidesPerView: num, slidesPerGroup: Math.floor(num) }}});
				}
			}
			
			
			// paginav 分頁鈕
			$.extend(true, paramOptions, { pagination: {
				el: $('[js-swiper-paginav]', o)[0] || (!!paramData.paginav ? $('[js-swiper-paginav='+paramData.paginav+']')[0] : null)
			}});
			if(!!paramData.pagination) {
				$.extend(true, paramOptions, { pagination: paramData.pagination });
			}
			
			// prevbtn, nextbtn 上下頁鈕
			$.extend(true, paramOptions, { navigation: {
				prevEl: $('[js-swiper-prevbtn]', o)[0] || (!!paramData.prevbtn ? $('[js-swiper-prevbtn='+paramData.prevbtn+']')[0] : null),
				nextEl: $('[js-swiper-nextbtn]', o)[0] || (!!paramData.nextbtn ? $('[js-swiper-nextbtn='+paramData.nextbtn+']')[0] : null)
			}});
		}
		
		// 最終Swiper instance要吃的 options
		//var options = $.extend(true, {}, basicOptions, instanceOptions, paramOptions);
		paramOptions = $.extend(true, {}, basicOptions, instanceOptions, paramOptions);
		
		// autoplay 輪播
		if(!paramOptions.autoplay || !paramOptions.autoplay.delay || $('.swiper-slide', o).length < 2) {//@20210628
			$.extend(true, paramOptions, {autoplay: false});
		}
		
		if($('.swiper-slide', o).length < 2) {//@20210628
			$.extend(true, paramOptions, {loop: false});
		} 
		
		//console.log('%c '+o.className.replace(/swiper-container/g,'') + ' %c' + JSON.stringify(paramOptions), 'font-weight:700;color:#fff;background:#24BCDC', 'color:#777;margin-left:20px');
		
		function init() {
			var swiper = new Swiper(o, paramOptions);
			
			if(!!io && o.swiper.autoplay !== false) {
				io.unobserve(o);
				io.observe(o);
			}
			
			// Page number @20210801
			if(!!paramData.fraction) {
				var el = $($('[js-swiper-fraction]', o)[0] || $('[js-swiper-fraction='+paramData.fraction+']')[0]);
				
				if(el.length > 0) {
					
					var curr = 1,
						total = swiper.slides.length;
					
					if(total > 1) {
						
						if(paramOptions.loop) {
							total = total - 2;
						}
						swiper.off('slideChange').on('slideChange', function(e){
							
							if(paramOptions.loop) {
								curr = swiper.realIndex + 1;
							}
							else {
								curr = swiper.activeIndex + 1;
							}
							el.find('.fraction-current').text(curr);
							
							//console.log('slideChange', swiper, curr + '/' + total);
						});
					}
					
					el.find('.fraction-current').text(curr);
					el.find('.fraction-total').text(total);
					
					el.css('opacity', 1);
				}
			} 
			
		};
		
		init();
		offAt(paramOptions.off, o, init);
	});
	
	function intersect(entries) {
		entries.forEach(function(entry) {
			var o = entry.target;
			if(!entry.isIntersecting && !!o.swiper && o.swiper.autoplay !== false && o.swiper.autoplay.running) {
				o.swiper.autoplay.stop();
				o.swiper.paused = true;
				//console.log('stopped autoplay', o);
			}
			else if(entry.isIntersecting && !!o.swiper && o.swiper.paused == true) {
				o.swiper.autoplay.start();
				//console.log('restart autoplay', o);	
			}
		});
	};
	
	/** 依據螢幕寬度移除 Swiper 或重新啟動
	 */
	function offAt(off, o, reInit) {
	   var media;
	   
		switch(off) {
			case 'sm':
				media = window.matchMedia('(min-width:433px)');
				break;
			case 'md':
				media = window.matchMedia('(min-width:769px)');
				break;
			case 'lg':
				media = window.matchMedia('(min-width:1153px)');
				break;
			case 'xl':
				media = window.matchMedia('(min-width:1537px)');
				break;
			default:
				media = window.matchMedia(off);
				break;
		}
		//console.log('off', off, o.className.replace(/swiper-container/g,''));
		if(off == 'never' || off=='xs' || !media) { return; }
		
		media.addListener(mediaCheck);	
		mediaCheck(media);
		
		function mediaCheck(e){
			if(e.matches && !!o.swiper){
				o.swiper.destroy(true, true);
				o.swiper = undefined;
				
				$(o).removeClass('swiper-container').addClass('swiper-container-off');
				$('.swiper-wrapper', o).removeClass('swiper-wrapper').addClass('swiper-wrapper-off');
				$('.swiper-slide', o).removeClass('swiper-slide').addClass('swiper-slide-off');
			}
			else{
				if(!o.swiper) {
					
					$(o).removeClass('swiper-container-off').addClass('swiper-container');
					$('.swiper-wrapper-off', o).removeClass('swiper-wrapper-off').addClass('swiper-wrapper');
					$('.swiper-slide-off', o).removeClass('swiper-slide-off').addClass('swiper-slide');
				
					reInit();
				}
			}
		}
	}
};

$.fn.swiperUpdate = function() {
	if(!window.Swiper) { return this; }
	
	var swiper = this.get(0).swiper;
	if(!!swiper) {
		swiper.updateAutoHeight();
		swiper.update();
	}
	return this;
};

$.fn.swiperRewind = function() {
	if(!window.Swiper) { return this; }
	
	var swiper = this.get(0).swiper;
	if(!!swiper) {
		swiper.update();
		swiper.slideTo(0);
	}
	return this;
};

// js-swiper-option 初始化
$(function(){
	if(!window.Swiper) { return; }
	
	// 全站套用
	$('[js-swiper-option]').swiperlist();	
	
	// or 個別套用
	//$('.XXXXX').swiperlist();
	//$('.XXXXX').swiperlist({ at: 'md', slidesPerView: 1 });
});


/** 橫向選單捲軸提示
 * @version 20210509
 * 
 * 支援兩種設定做法
 * 
 * (1) Browser native overflow scrollbar -
 *
 * 	   <div js-scrollhint="holder">
 *        <div js-scrollhint="scroller">
 *         	 <div>item</div>
 *         	 <div class="active">item</div>  <!-- active item -->
 *         	 <div>item</div>
 *        </div>
 *     </div>
 *     
 * (2) 搭配 Swiper.js "freemode" -
 *
 * 	   HTML列表結構需綁定 Swiper 必要 class (.swiper-containter, .swiper-wrapper, .swiper-slide)，
 * 	   參見 js/partials/_scrollhint.js 說明
 *
 *     <div class="swiper-container" js-scrollhint="holder" js-swiper-option='{"xs":"auto", "autoHeight":false, "freeMode":true}'>
 *     	 <div class="swiper-wrapper" js-scrollhint="scroller">
 *     		<div class="swiper-slide">item</div>
 *     		<div class="swiper-slide active">item</div> <!-- active item -->
 *     		<div class="swiper-slide">item</div>
 *     		...
 *     	 </div>
 *     </div>
 *************************/
$(function(){
	if(!$('[js-scrollhint]')[0]) { return; }
	
	$('[js-scrollhint="holder"]').each(function(){
		var holder = $(this),
			scroller = $('[js-scrollhint="scroller"]', holder);
		
		if(!!$('.scrollhint', holder)[0]) { return true; }
		
		$('<div class="scrollhint"></div>').appendTo(holder);
		$('.scrollhint', holder).on('click', function(e){
			var swiper = holder.get(0).swiper;
			if(!!swiper) {
				swiper.slideNext();
			}
			else {
				scroller.animate({scrollLeft: scroller.scrollLeft() + 100}, 168);
			}
		});
		
		if(!/abs|rel/.test(holder.css('position'))) {
			holder.css('position', 'relative');
		}
	});
	
	render();
	setTimeout(render, 500);
	$(window).on('resize', $.debounce(500,render));
	
	function render() {
		$('[js-scrollhint="holder"]').each(function(){
			var holder = $(this),
				scroller = scroller = $('[js-scrollhint="scroller"]', holder),
				state = 'scrollhint--show';
				
			var sw = scroller.get(0).scrollWidth;
			var hw = holder.outerWidth() + 10;
			
			if(sw > hw && !holder.hasClass(state)) {
				holder.addClass(state);
			}
			else if(sw <= hw && holder.hasClass(state)) {
				holder.removeClass(state);
			}
			//console.log('scroll width='+sw, 'holder width'+hw);
			
			
			// 捲到 active item 定位
			var activeBtn = $('.active', scroller);
			
			if(activeBtn[0]) {
				var swiper = holder.get(0).swiper;
				// Swiper
				if(!!swiper) {
					swiper.slideTo(activeBtn.index(), 0);
				}
				// Native overflow-x:auto
				else {
					var x = Math.max(0, activeBtn.get(0).offsetLeft/* - activeBtn.outerWidth()*/);
					scroller.scrollLeft(x);
				}
			}
		});
	}
});

/** Fix mobile webkit 100vh 
 *************************/
(function(){
	if(base.getWinW()<=1152) {
		var el = document.querySelector('.homekv-inner') || document.querySelector('.pagekv-inner');
		if(!el) { return; }
		var vh = base.getWinH() - 60;
		if(vh > 400) {
			el.style.height = vh + 'px';
		}
	}
})();


/** Foldable
 *************************/
$(function(){
	var state = 'foldable--expanded';
	
	$(document).on('click.foldable', '[js-foldable-head]', function(e){
		e.preventDefault();
		
		var holder = $(this).parents('[js-foldable-group]'),
			id = holder.attr('js-foldable-group'),
			head = $(this),
			body = holder.find('[js-foldable-body]');
		
		if(holder.hasClass(state)) {
			body.slideUp(300, function(){
				head.trigger('foldAfterClose', [head, body, id]);
			});
			holder.removeClass(state);
			head.trigger('foldBeforeClose', [head, body, id]);
		}
		
		else {
			body.slideDown(300, function(){
				head.trigger('foldAfterOpen', [head, body, id]);
			});
			holder.addClass(state);
			head.trigger('foldBeforeOpen', [head, body, id]);
		}
		
		// 綁定 js-foldable-group 連動收合
		if(!!id) {
			$('[js-foldable-group="'+ id +'"]').not(holder).each(function(){
				$(this).removeClass(state)
					.find('[js-foldable-body]').slideUp(300);
			});
		}
	});
	
	// Initialize
	$('.'+state+' > [js-foldable-body]').show();
});


/** Newstick 
 *************************/
$(function(){
	$(document).on('click', '.newstick-dismiss', function(e){
		$('.newstick').slideUp(200);
	});
});



/** Comfort gallery change title with slidechange
 * must comes after _swiperlist.js initialization
 *************************/
$(function(){
	$('.comfort').each(function(){
		var o = this,
			el = $('.swiper-container', o)[0];
		
		if(!!el && el.swiper) {
			el.swiper.on('slideChange', function(e){
				//console.log(el.swiper.realIndex);
				$('.comfort-item-title', o).eq(el.swiper.realIndex).addClass('active')
					.siblings().removeClass('active');
			});
		}
	});
});


/** Staff detail
 *************************/
$(function(){
	var detailHolder = $('[js-staff-detail]');
	
	if(!detailHolder[0]) { return; }
	
	$(document).on('click', '[js-staff]', function(e){
		var el = $(this);
		
		if(el.hasClass('active')) {
			close();
		}
		else {
			if(detailHolder.hasClass('detail--open')) {
				detailHolder.slideUp(300, function(){
					open(el);
					
					base.ignoreNextScrollEvent = true;
					$('html').removeClass('scrolled-up').addClass('scrolled-down');
					base.scrollTo(this, {offset: 0, always: function(){
						setTimeout(function(){
							base.ignoreNextScrollEvent = false;
						}, 100);
					}});
				});
			} else {
				open(el);
			}
			
			
			
		}
	});
	
	$(document).on('click', '.staff-dismiss', function(e){
		close();
	});
	
	var currRow;
	
	function open(staff) {
		var grid = 1,
			basis = $('.team-col').css('flex-basis'),
			selectedIndex,
			targetIndex,
			row,
			teamCol,
			total = $('.team-col').length;
		
		switch(true) {
			case /25/.test(basis): grid = 4; break;
			case /33/.test(basis): grid = 3; break;
			case /50/.test(basis): grid = 2; break;
		}
		
		selectedIndex = staff.parents('.team-col').index('.team-col') + 1;
		row = Math.ceil(selectedIndex / grid);
		targetIndex = Math.min(total, row*grid) - 1;
		
		teamCol = $('.team-col').eq(targetIndex);
		
		//console.log(selectedIndex, targetIndex);
		
		if(row == currRow) {
		}
		else {
			detailHolder.hide();
		}
		detailHolder.removeClass('detail--open');
		
		
		$('[js-staff-data1]', detailHolder).html( staff.find('[js-staff-data1]').clone() );
		$('[js-staff-data2]', detailHolder).html( staff.find('[js-staff-data2]').clone() );
		detailHolder.insertAfter(teamCol);
		
		detailHolder.slideDown(600);
		
		setTimeout(function(){
			detailHolder.addClass('detail--open');
		}, 31);
		
		staff.addClass('active');
		$('.active[js-staff]').not(staff).removeClass('active');
		
		currRow = row;
	}
	
	function close() {
		detailHolder.slideUp(600, function(){
			setTimeout(function(){
				!!base.anims && base.anims.refresh();
			}, 100);
		});
		detailHolder.removeClass('detail--open');
		$('.active[js-staff]').removeClass('active');
	}
});


/** Convert SVG file into an inline SVG element
 *************************/
/*$(function(){
	$('[js-inlineSVG]').each(function(){
		var src = $(this).attr('src');
		inlineSVG(src, this);
	});
});*/

function inlineSVG(src, el) {
    var loadXML = new XMLHttpRequest;
    function response(){
		var html = loadXML.responseText;
        if(loadXML.readyState == 4 && /<svg/.test(html)){
			if(el.className) {
				html = html.replace('<svg', '<svg class="' + el.className + '"');
			}
			//console.log(html);
			el.outerHTML = html;
			
			!!base.anims && base.anims.refresh();
        }
    }
	
    if(loadXML != null){
        loadXML.open("GET", src, true);
        loadXML.onreadystatechange = response;
        loadXML.send();
    }
}


/** SMIL morph bubble 
 *************************/
$.fn.svgPause = function(){
	return this.each(function(){
		this.pauseAnimations();
	});
};
$.fn.svgResume = function(){
	return this.each(function(){
		this.unpauseAnimations();
	});
};
$(function(){
	if(!!$('.cherimenu-pool')[0] && $('.cherimenu-pool').attr('js-d2') != 'true') { return; }

	$('path[js-d2]').each(function(){
		var d = $(this).attr('d'),
			d2 = $(this).attr('js-d2'),
			ease = $(this).attr('js-d2-ease') || '.42,0,.58,1',
			r = Math.floor(Math.random()*10)%3,
			rotate = $(this).attr('js-d2-rotate') || (r==0?'0;15;0;-15;0':r==1?'0;-14;0;14;0':'0;-10;0;12;0'),
			dur = 4;
		
		var morph = '<animate attributeName="d" dur="'+dur+'s" '+
					'calcMode="spline" keySplines="'+ease+';'+ease+'" '+
					'repeatCount="indefinite" fill="freeze" values="'+d+';'+d2+';'+d + '"/>';
			
		var scale = '<animateTransform attributeName="transform" dur="'+
					(dur*4)+'s" repeatCount="indefinite" values="'+
					rotate +'" type="rotate"/>';
			
		$(this).html(morph);
		$(this).after(scale);
		$(this).parent().html($(this).parent().html());
	});

});


/** Swap btn text when hovering
 * .btn-block only
  *************************/
$(function(){
	$('.btn-block[js-txt2]').each(function(){
		// Store original button text
		this.txt = $('>span', this).text();
		this.txt2 = $(this).attr('js-txt2');
		//console.log(this.txt, this.txt2);
		// Swap text
		$(this).on('mouseover mouseout mouseleave', function(e){
			$('>span', this).text( e.type == 'mouseover'? this.txt2 : this.txt );
		});
	});
});


/** Cherimenu
 */
$(function(){
	var cherimenu = $('.cherimenu');
	if(!cherimenu[0]) { return; }
	
	var wait;
	
	$('.cherimenu-btn')
		.on('mouseenter click', function(e){
			var btn = $(this);
			
			clearTimeout(wait)
			wait = setTimeout(function(){
				selectItem(btn)
			}, e.type == 'mouseenter' ? 200: 0);
		})
		
		.on('mouseleave', function(e){
			clearTimeout(wait)
			$(this).removeClass('over');
			resumeAll();
		});
		
	function selectItem(btn) {
		var id;
		
		btn.addClass('over').siblings().removeClass('over');
		
		id = btn.attr('js-id');
		$('.cherimenu-item[js-id="'+ id +'"]').addClass('active')
			.siblings().removeClass('active');
		$('.cherimenu-default').hide();
		
		pauseAll();
		$('svg', btn).svgResume();
	};
	
	function pauseAll() {
		$('svg', cherimenu).svgPause();
		//console.log('pauseAll');
	};
	
	function resumeAll(){
		$('svg', cherimenu).svgResume();
		//console.log('resumeAll');
	}
	
	if('IntersectionObserver' in window){
		var io = new IntersectionObserver(intersect);
		io.observe(cherimenu.get(0));
	}
	
	function intersect(entries) {
		var entry = entries[0];
		if(!entry.isIntersecting) {
			pauseAll();
			
			$('.cherimenu-default').show();
			$('.cherimenu-item').removeClass('active');
			$('.cherimenu-btn').removeClass('over');
		}
		else if(entry.isIntersecting) {
			resumeAll();
		}
	};
	
});


/** About branding animation viewport observering
 *************************/
;(function(){
	var el = document.querySelector('.brand');
	if(!el) { return; }
	
	if('IntersectionObserver' in window){
		var io = new IntersectionObserver(intersect);
		io.observe(el);
	}
	
	function intersect(entries) {
		var entry = entries[0];
		if(entry.isIntersecting) {
			document.documentElement.classList.add('brand--animate');
		}
		else {
			document.documentElement.classList.remove('brand--animate');
		}
	};
})();


/** IE 11+ position:sticky polyfill
 *************************/
$(function(){
	var el = $('.brand-playhead, .cheripg_art, .pagemenu');
	if(!!el[0] && window.navigator.msPointerEnabled) { Stickyfill.add(el); }
});


/** Postpartum pagemenu
 *************************/
$(function(){
	$('.pptm_pagemnu .pagemenu-link').on('click', function(e){
		var target = $(this).attr('href');
		var scrollOffset = -$('.masthead').height();
		
		base.waypointLocked = true;
		base.ignoreNextScrollEvent = true;
		$('html').removeClass('scrolled-up').addClass('scrolled-down');
		base.scrollTo( target, {
			offset: scrollOffset,
			always:function(){
				setTimeout(function(){
					base.waypointLocked = false;
					base.ignoreNextScrollEvent = false;
				}, 100);
			}
		});
		
		$(this).parent().siblings().removeClass('active');
		$(this).parent().addClass('active');
		
		e.preventDefault();
	});
});


/** Simple waypoint menu active state
 * using InteractionObserver
 * @version 20210803
 *************************/
base.waypointLocked = false;

$(function(){
	var btnState = 'active';
	
	var sections = $(''); // empty set
	
	$('[js-waypoint]').each(function(){
		var target = $(this).attr('js-waypoint') || $(this).attr('href');
		
		if($(target).length == 0) {
			return true;
		}
		sections = sections.add($(target).get());
	});
	
	if(sections.length == 0 || typeof window.IntersectionObserver === 'undefined') {
		return;
	}
		
	//sconsole.log(sections.length, sections);
	
	var io = new IntersectionObserver(intersect, {
		rootMargin: '-45% 0% -45% 0%' // Shrink viewport to a laser-like area to scan intersected elements
									  // https://blog.arnellebalane.com/the-intersection-observer-api-d441be0b088d
	});
	sections.each(function(){
		io.observe(this);
	});
	
	function intersect(entries) {
		if( base.waypointLocked ) {
			return;
		}
		
		entries.forEach(function(entry){
			var id = entry.target.id,
				btn = $($('[js-waypoint*="'+ id +'"]')[0] || $('[js-waypoint][href*="'+ id +'"]')[0]);
			
			if(btn.length > 0) {
				//console.log(id, entry.intersectionRatio);
				if(entry.isIntersecting) {
					//console.log('intersect IN --->', id);
					btn.addClass(btnState);
					$('[js-waypoint]').not(btn).removeClass(btnState);
				}
				
				else {
					if(btn.is('[js-waypoint-first]') && entry.boundingClientRect.y > 0  ||
					   btn.is('[js-waypoint-last]')  && entry.boundingClientRect.y < 0 ) {
						//if(/product/.test(id)) console.log('intersect OUT --->', id,  entry.boundingClientRect);
						$('[js-waypoint]').removeClass(btnState);
					}
				}
			}
		});
	};
});


/** Swiper control
 */
$(function(){
	$(document).on('click', '.swiper-control .btn-arrow-next, .swiper-control btn-arrow-prev', function(e){
		$('html').removeClass('scrolled-up').addClass('scrolled-down');
	});
});



/** Scroll cursor on swiper
 */
//$(function(){
//	$(document).on('mouseenter mousemove mousedown mouseup mouseleave', '.testist-list', function(e){
//		var cursor = $('.cursor-scroll', this),
//			x, y,
//			x0 = parseFloat(cursor.offset().left),
//			y0 = parseFloat(cursor.offset().top),
//			f = 12;
//			
//		x += (e.pageX - x0)/f;
//		y += (e.pageY - y0)/f;
//		
//		console.log(x, y);
//		
//		cursor.offset({left:x, top:y});
//	});
//});




